import { cx } from "@/utils";

export default function SidebarLabel({ className, ...props }) {
  return <span {...props} className={cx("truncate", className)} />;
}
